import ar from './ar.json';
import en from './en.json';

/**
 * The Dashboard module's catalogue (D12), registered from `app.config.tsx`
 * under the `dashboard` namespace — `shared/i18n` never imports a module (W2).
 */
export const dashboardCatalogs = { ar, en };
